import { sbefGroupIds } from '@shared/construction/sbef.model';
import { SbefScopeGroupKey } from '@shared/construction/sbef-custom-groups.data';
import {
  getSbefGroupByCode,
  SITE_OPERATIONS_SBEF_GROUP_KEY,
  SITE_OPERATIONS_SBEF_GROUP_LABEL,
} from '@shared/helpers/sbef-grouping.helpers';

export type SbefGroupOption = {
  /** SBEF scope group key (standard first digit or custom group id). */
  key: SbefScopeGroupKey;
  /** Human-readable label shown in menus and summaries. */
  label: string;
  /** Optional tooltip copy for the scope selector; defaults to {@link SbefGroupOption.label}. */
  description?: string;
};

/**
 * Selectable SBEF groups in the scope selector: the ten standard groups (`'0'`–`'9'`).
 * Group 9 is Site operations (common works, general content, and 100-series codes).
 * A5.1 and A5.2-5 are omitted — they follow the Embodied A5 lifecycle toggle.
 */
export const SBEF_GROUP_OPTIONS: readonly SbefGroupOption[] = sbefGroupIds.map(
  (id) => ({
    key: id,
    label:
      id === SITE_OPERATIONS_SBEF_GROUP_KEY
        ? SITE_OPERATIONS_SBEF_GROUP_LABEL
        : getSbefGroupByCode(id).label,
    ...(id === SITE_OPERATIONS_SBEF_GROUP_KEY
      ? {
          description: getSbefGroupByCode(id).label,
        }
      : {}),
  }),
);

export const ALL_SBEF_GROUP_KEYS: readonly SbefScopeGroupKey[] =
  SBEF_GROUP_OPTIONS.map((option) => option.key);

/** Short label for inline SBEF scope toggles (standard group digit). */
export const getSbefScopeGroupPrefix = (key: SbefScopeGroupKey): string => key;
